<template functional>
	<div class="c-crawler-only" inert>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'CrawlerOnly',
};
</script>

<style lang="postcss">
.c-crawler-only {
	@apply sr-only;
}
</style>
